import React from 'react';
import cx from 'classnames';

import FAQSection from '../../landingPages/FAQSection/FAQSection';
import type { FAQType } from '../UlezPage.types';

import styles from './UlezFAQ.scss';

type UlezFaqProps = {
  faq: FAQType[];
  title: string;
};

const UlezFAQ = ({ faq, title }: UlezFaqProps) => {
  if (!faq.length) {
    return null;
  }

  const className = cx(styles.ulezFAQ);

  return (
    <FAQSection {...{ className, faq, title } as any} />
  );
};

export default UlezFAQ;
